import PropTypes from 'prop-types';
import React from 'react';
import { Common } from 'ws-scripts/modules/common';
import { FOOTNOTE_INDICATOR, DEALER_OFFER } from '../constants/constants';

export default class IncentiveLink extends React.Component {
	constructor(props) {
		super(props);
		this.showModal = this.showModal.bind(this);
	}

	showModal() {
		this.props.showModalData(this.props.incentive, true);
	}

	render() {
		const {
			showFootnote,
			incentive: { key, title, shortTitle }
		} = this.props;
		let footnoteIndicator = null;

		if (showFootnote) {
			footnoteIndicator = (
				<span className="footnote-indicator">{FOOTNOTE_INDICATOR}</span>
			);
		}

		return (
			<Common
				render={({ prefs, labels, flags }) => {
					let offerTitle = title;

					// TODO: restore tests in IncentiveLink.test.jsx (and one additional in widget.test.jsx)
					// TODO: extract this to function outside the render and make it a switch statement
					if (
						flags[
							'ws-detailed-incentives-show-alternate-incentive-titles'
						]
					) {
						offerTitle = shortTitle;

						if (prefs.incentiveTitleDisplay === 'regular') {
							offerTitle = title;
						}

						if (prefs.incentiveTitleDisplay === 'custom') {
							offerTitle =
								labels.get(prefs.incentiveTitleCustom) ||
								labels.get(DEALER_OFFER);
						}
					}
					if (
						flags['ws-detailed-incentives-filtered-and-categorized']
					) {
						return (
							<li className="py-3 my-0">
								<button
									className="text-link text-left"
									onClick={this.showModal}
								>
									<span className="incentive-title">
										{offerTitle}
									</span>
									{footnoteIndicator}
								</button>
							</li>
						);
					} else {
						return (
							<li className="py-3 my-0" key={`${key}a`}>
								<button
									className="text-link text-left"
									onClick={this.showModal}
								>
									{offerTitle}
								</button>
							</li>
						);
					}
				}}
			/>
		);
	}
}

IncentiveLink.propTypes = {
	incentive: PropTypes.shape({
		key: PropTypes.string,
		title: PropTypes.string.isRequired,
		shortTitle: PropTypes.string.isRequired
	}).isRequired,
	showModalData: PropTypes.func.isRequired,
	showFootnote: PropTypes.bool
};

IncentiveLink.defaultProps = {
	showFootnote: false
};



// WEBPACK FOOTER //
// ./src/components/IncentiveLink.jsx